import React from "react";
import { func, bool, string } from "prop-types";

import "./hamburger.m.css";

const HamburgerIcon = ({
  onMenuToggle,
  isNavbarOpen,
  isDesktop,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => (
  <div
    onClick={onMenuToggle}
    styleName={`hamburger ${!isDesktop && isNavbarOpen ? "is-open" : ""}`}
    className="hamburger"
    aria-label="Close"
    data-tracking-category={datatrackingcategory}
    data-tracking-action={datatrackingaction}
    data-tracking-label={datatrackinglabel}
  >
    <div
      styleName="line"
      className="hamburger-line"
      data-tracking-category={datatrackingcategory}
      data-tracking-action={datatrackingaction}
      data-tracking-label={datatrackinglabel}
    />
    <div
      styleName="line"
      className="hamburger-line"
      data-tracking-category={datatrackingcategory}
      data-tracking-action={datatrackingaction}
      data-tracking-label={datatrackinglabel}
    />
    <div
      styleName="line"
      className="hamburger-line"
      data-tracking-category={datatrackingcategory}
      data-tracking-action={datatrackingaction}
      data-tracking-label={datatrackinglabel}
    />
  </div>
);

export default HamburgerIcon;

HamburgerIcon.propTypes = {
  onMenuToggle: func,
  isNavbarOpen: bool,
  isDesktop: bool,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};
